// Internal modules
import { logger } from '@/lib/logger';
import { getGlobals, getToken } from '@/lib';

const COMMON_KEYS = {
  component: 'checkoutuinodeweb_weasley',
};

export const logExperimentationDetails = (
  isEligible: boolean,
  ineligiblityReason: Array<string>,
): void => {
  const experimentNameDelayed = 'FEATURE_SIGNUP_INCENTIVES_DELAYED';
  const experimentDetails = getGlobals().experiments[experimentNameDelayed];
  const fptiPayload = {
    context_id: getToken(),
    context_type: 'EC-Token',
    event_name: 'checkout_client_experimentation_decision_occurred',
    experimentation_experience: experimentDetails?.experimentId,
    experimentation_treatment: experimentDetails?.treatmentId,
    product: 'checkout',
    reason: JSON.stringify([
      {
        eligibility: isEligible,
        reason: isEligible ? [] : ineligiblityReason,
        xe: experimentDetails?.experimentId,
        xt: experimentDetails?.treatmentId,
      },
    ]),
    state_name: 'client_eligibility_check',
    transition_name: 'process_client_eligiblity_check',
  };

  logger.fpti('checkout_client_experimentation_decision_occurred', fptiPayload);
};

export const logGetOfferButtonClick = (): void => {
  logger.fpti('billing_review_signup_incentive_module_get_pressed', {
    event_name: 'billing_review_signup_incentive_module_get_pressed',
    state_name: 'billing_review_incentive_module',
    transition_name: 'process_billing_review_incentive_module_get',
    ...COMMON_KEYS,
  });
};

export const logIncentiveShown = (): void => {
  logger.fpti('billing_review_signup_incentive_module_shown', {
    event_name: 'billing_review_signup_incentive_module_shown',
    state_name: 'billing_review_incentive_module',
    transition_name: 'prepare_billing_review_incentive_module',
    ...COMMON_KEYS,
  });
};

export const logIncentiveConfirmationShown = (): void => {
  logger.fpti('billing_review_signup_incentive_confirmation_module_shown', {
    event_name: 'billing_review_signup_incentive_confirmation_module_shown',
    state_name: 'billing_review_incentive_confirmation_module',
    transition_name: 'prepare_billing_review_incentive_confirmation_module',
    ...COMMON_KEYS,
  });
};
